import config from '@/config'
import AppInfo from '@/api/appinfo'
import { versionCompare } from '@/utils/helpers'

const webVersion = require('../../../package.json').version

interface State {
  appName: string
  appVersion: string
  storeUrl: string
  MAIL_ADDRESS_SUPP: string
  mustUpdate: boolean
  rejectedAndroid: boolean
  apkDownloadURL: string
}

const defaultState: State = {
  appName: config.APP_NAME,
  appVersion: '',
  storeUrl: '',
  MAIL_ADDRESS_SUPP: config.MAIL_ADDRESS_SUPP,
  mustUpdate: false,
  rejectedAndroid: false,
  apkDownloadURL: ''
}

const state: State = { ...defaultState }

const actions = {
  /**
   * Android アプリがリジェクトされたチェック
   */
  checkRejectAndroid({ state, commit }, payload: any): Promise<any> {
    return AppInfo.checkRejectAndroid({
      ...payload
    }).then(data => {
      // 今のバージョンがリジェクトされたのと同じか低いなら
      const rejectedAndroid = data.is_reject_android
        ? state.appVersion === data.version || !versionCompare(state.appVersion, data.version)
        : false

      commit('setRejectedAndroid', rejectedAndroid)
      commit('setApkDownloadURL', data.url)

      return data
    })
  },

  /**
   * アプリのアップデートが必要かチェックし, 必要であればアップデートを促す
   */
  checkMustUpdate({ commit }, params): Promise<any> {
    return AppInfo.checkMustUpdate(params)
      .then(data => {
        if (data.error) {
          console.error(data.error)
          return
        }

        commit('setMustUpdate', data.must_update)
        if (data.must_update) {
          commit('setStoreUrl', data.store_url)
        }
      })
      .catch(err => {
        throw err
      })
  }
}

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  setAppName(state: State, name: string) {
    state.appName = name
  },

  setAppVersion(state: State, version: string) {
    state.appVersion = version
  },

  setStoreUrl(state: State, storeUrl: string) {
    state.storeUrl = storeUrl
  },

  setMustUpdate(state: State, mustUpdate: boolean) {
    state.mustUpdate = mustUpdate
  },

  setRejectedAndroid(state: State, rejectedAndroid: boolean) {
    state.rejectedAndroid = rejectedAndroid
  },

  setApkDownloadURL(state: State, apkDownloadURL: string) {
    state.apkDownloadURL = apkDownloadURL
  }
}

const getters = {
  appName: (state: State): string => state.appName,
  /**
   * 初回起動時はなぜか appVersion がセットされていない対策
   */
  appVersion: (state: State): string =>
    state.appVersion ? state.appVersion : sessionStorage.getItem('appVersion'),
  webVersion: (): string => webVersion,
  storeUrl: (state: State): string => state.storeUrl,
  MAIL_ADDRESS_SUPP: (state: State): string => state.MAIL_ADDRESS_SUPP,
  mustUpdate: (state: State): boolean => state.mustUpdate,
  rejectedAndroid: (state: State): boolean => state.rejectedAndroid,
  apkDownloadURL: (state: State): string => state.apkDownloadURL
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
